import type { IForItemProps } from '../c-mp/comp/For'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { url } from '../c-mp/fun/url'
import { formatNumber } from '../fun/formatNumber'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getPersonNameFormatted } from '../fun/getPersonNameFormatted'
import { _ } from '../model/ccc'
import type { IContemporary } from '../model/IContemporary'
import { PortraitComp } from './PortraitComp'

export const ContemporaryLinkComp = defineComponent<
	IForItemProps<IContemporary>
>('ContemporaryLinkComp', ({ get: getContemporary }, $) => {
	const data = getDataOrThrow()

	return (
		<a
			class={_.ccc_button__person}
			href={() => url`/person/${getContemporary().person.id}`}
		>
			<PortraitComp getPerson={() => getContemporary().person} />
			<div>
				<Slot
					get={() => getPersonNameFormatted(data, getContemporary().person)}
				/>{' '}
				<div class={_.ccc_date}>
					<Slot get={() => getAgeDifferenceFormatted(getContemporary())} />
				</div>
			</div>
		</a>
	)
})

function getAgeDifferenceFormatted(contemporary: IContemporary) {
	let result
	if (contemporary.ageDiff === 0) {
		result = 'egyidős vele'
	} else {
		result = `${formatNumber(Math.abs(contemporary.ageDiff))} évvel ${contemporary.ageDiff < 0 ? 'fiatalabb' : 'idősebb'}`
	}
	return contemporary.ageAssumed ? (
		<span class={_.ccc_unknown}>{result}?</span>
	) : (
		<b>{result}</b>
	)
}
